module.exports = __webpack_public_path__ + "18363ce8df2da99814e904d3e4cfad76.png";